import axiosInstance from '@/plugins/api/axiosInstance';
import generateQueryParams from '@/utils/generateQueryParams';

export default function consolcheck() {
    return {
        get,
        index,
        create,
        addpiece
    };

    function get(id) {
        return axiosInstance.get(`consolcheck/get?id=${id}`);
    }

    function index(options = {}) {
        const defaultValues = {
            pattern: '',
            limit: 25,
            page: 1,
            consolId: options?.consolId
        };
        const params = generateQueryParams(
            { ...options, consolId: options.consolId },
            defaultValues
        );
        return axiosInstance.get(`consolcheck/list${params}`);
    }

    function create(data) {
        return axiosInstance.post('consolcheck/create', data);
    }

    function addpiece(data) {
        return axiosInstance.post('consolcheck/add-piece', data);
    }
}
